import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { CardComponent, RealEstateObject } from '@immosky/types';
import { DetailPageService } from '../../services/detail-page.service';
import { I18nService } from '../../i18n/i18n.service';

@Component({
  selector: 'lib-list-card',
  templateUrl: './list-card.component.html',
  styleUrls: ['./list-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListCardComponent
  implements CardComponent<RealEstateObject>, OnInit
{
  @Input()
  data!: RealEstateObject;

  @Input()
  hasSlider = true;

  detailPageUrl = '';

  title = '';
  price = '';

  constructor(
    private cdRef: ChangeDetectorRef,
    private detailPageService: DetailPageService,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.setDetailPageUrl();
    this.buildTitle();
    this.buildPrice();
  }

  private setDetailPageUrl() {
    this.detailPageUrl = this.detailPageService.getDetailPageUrlForId(
      this.data.id
    );
    this.cdRef.markForCheck();
  }

  private buildTitle() {
    const mainTitle = this.i18nService.transform(this.data.title);

    if (this.data.isAlsoIncomeProperty) {
      const incomePropertyTitle = this.i18nService.transform(
        'filters.category.main.incomeProperty'
      );

      this.title = `${mainTitle}, ${incomePropertyTitle}`;
    } else {
      this.title = mainTitle;
    }
  }

  private buildPrice() {
    this.price = this.i18nService.renderPrice(this.data);
  }

  onLinkClick() {
    if (this.data.status !== 'sold') {
      this.detailPageService.goTo(this.detailPageUrl, 'list-card');
    }
  }
}
